import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { BookOpen, Headphones, Leaf, ShieldAlert, CheckCircle2, Gift } from 'lucide-react';
export function ValueStack() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-amber-400" data-id="element-281" />,
    title: 'Ebook "Protocolo Reinicio"',
    desc: 'La guía de 20 páginas para resetear tu mente.',
    value: '$25.000 ARS',
    isMain: true
  }, {
    icon: <Headphones className="w-6 h-6 text-emerald-400" data-id="element-282" />,
    title: 'BONO 1: Audio "Hipnosis de Sueño"',
    desc: 'Ponete los auriculares y dormite en 5 min.',
    value: '$12.000 ARS',
    isMain: false
  }, {
    icon: <Leaf className="w-6 h-6 text-emerald-400" data-id="element-283" />,
    title: 'BONO 2: Guía de Suplementos Naturales',
    desc: 'Qué comprar en la dietética para relajar el cuerpo.',
    value: '$8.000 ARS',
    isMain: false
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-emerald-400" data-id="element-284" />,
    title: 'BONO 3: Checklist SOS Pánico',
    desc: 'Qué hacer si sentís que te falta el aire.',
    value: '$10.000 ARS',
    isMain: false
  }];
  return <section className="py-24 bg-[#0f172a] relative" data-id="element-285">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-900/10 via-[#0f172a] to-[#0f172a] pointer-events-none" data-id="element-286"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-287">
        <FadeIn data-id="element-288">
          <div className="text-center mb-12" data-id="element-289">
            <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-290">
              Todo lo que te llevás hoy
            </h2>
            <p className="text-xl text-slate-400" data-id="element-291">
              Acceso inmediato y de por vida a todo el material.
            </p>
          </div>
        </FadeIn>

        <div className="grid lg:grid-cols-5 gap-8 items-start" data-id="element-292">
          {/* Stack List */}
          <div className="lg:col-span-3 space-y-4" data-id="element-293">
            {items.map((item, index) => <FadeIn key={index} delay={index * 100} data-id="element-294">
                <div className={`p-5 rounded-2xl border flex items-start gap-4 transition-colors ${item.isMain ? 'bg-slate-800/80 border-amber-500/50 shadow-[0_0_30px_-10px_rgba(245,158,11,0.2)]' : 'bg-slate-800/40 border-slate-700/50'}`} data-id="element-295">
                  <div className={`p-3 rounded-xl ${item.isMain ? 'bg-amber-500/10' : 'bg-emerald-500/10'}`} data-id="element-296">
                    {item.icon}
                  </div>
                  <div className="flex-grow" data-id="element-297">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-1" data-id="element-298">
                      <h3 className="text-lg font-bold text-white flex items-center gap-2" data-id="element-299">
                        {item.title}
                        {!item.isMain && <span className="text-[10px] uppercase tracking-wider bg-emerald-500/20 text-emerald-400 px-2 py-0.5 rounded-full font-bold flex items-center gap-1" data-id="element-300">
                            <Gift className="w-3 h-3" data-id="element-301" /> GRATIS
                          </span>}
                      </h3>
                      <span className="text-slate-500 line-through text-sm font-medium" data-id="element-302">
                        {item.value}
                      </span>
                    </div>
                    <p className="text-slate-400 text-sm" data-id="element-303">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>

          {/* Pricing Card */}
          <div id="pricing" className="lg:col-span-2" data-id="element-304">
            <FadeIn delay={400} direction="left" data-id="element-305">
              <div className="bg-gradient-to-b from-slate-800 to-slate-900 rounded-3xl border-2 border-amber-500/50 p-8 shadow-2xl shadow-black/50 relative overflow-hidden" data-id="element-306">
                {/* 70% OFF Badge */}
                <div className="absolute top-6 right-6 bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full animate-pulse shadow-lg shadow-red-500/50" data-id="element-307">
                  76% OFF
                </div>

                <div className="text-center mb-8" data-id="element-308">
                  <p className="text-slate-400 font-medium mb-2" data-id="element-309">
                    VALOR TOTAL:{' '}
                    <span className="line-through" data-id="element-310">$55.000 ARS</span>
                  </p>
                  <p className="text-sm text-amber-400 font-bold uppercase tracking-wider mb-2" data-id="element-311">
                    Precio de Lanzamiento Hoy
                  </p>
                  <div className="flex items-end justify-center gap-2 mb-2" data-id="element-312">
                    <span className="text-5xl font-extrabold text-white" data-id="element-313">
                      $9.90
                    </span>
                    <span className="text-xl text-slate-300 font-medium mb-1" data-id="element-314">
                      USD
                    </span>
                  </div>
                  <p className="text-slate-400 text-sm" data-id="element-315">(Aprox. $12.900 ARS)</p>
                </div>

                <ul className="space-y-3 mb-8" data-id="element-316">
                  <li className="flex items-center gap-3 text-slate-300 text-sm" data-id="element-317">
                    <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-318" />
                    <span data-id="element-319">Pago único, sin suscripciones</span>
                  </li>
                  <li className="flex items-center gap-3 text-slate-300 text-sm" data-id="element-320">
                    <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-321" />
                    <span data-id="element-322">Acceso inmediato al PDF y Audios</span>
                  </li>
                  <li className="flex items-center gap-3 text-slate-300 text-sm" data-id="element-323">
                    <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-324" />
                    <span data-id="element-325">Se puede pagar en pesos</span>
                  </li>
                </ul>

                <CTAButton fullWidth isCheckout className="mb-4" data-id="element-326">
                  LO QUIERO AHORA
                </CTAButton>

                <p className="text-center text-xs text-slate-500 flex items-center justify-center gap-1" data-id="element-327">
                  <ShieldAlert className="w-3 h-3" data-id="element-328" /> Pago 100% seguro y
                  encriptado
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}